<template>
  <f7-page name="ccm-pat-apply" class="page-bg-render">
    <f7-navbar>
      <div class="title">
				<span v-if="mode=='ANSWER'">답안입력</span>
        <span v-else>채점결과</span>
      </div>
			<f7-nav-right>
        <f7-link icon-ios="f7:close" icon-aurora="f7:close" icon-md="material:close" class="back"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <f7-block-title>
			<div class="display-flex">
				<div>
					<span v-if="clinicMode == 'incorrect'">오답문제 다시풀기</span>
					<span v-if="clinicMode == 'similar'">오답유사 문제풀기</span>
				</div>
				<div style="align-self: flex-end; margin-left: auto;">
					<a href="#" @click="toggleViewMode()">
						<span v-if="viewMode=='ANSWER-VIEW'">문제보기</span>
						<span v-else>답란보기</span>
					</a>
				</div>
			</div>
		</f7-block-title>

		<template v-if="viewMode=='ANSWER-VIEW'">
			<div class="list">
				<ul v-if="answers.length">
					<li v-for="(exam, i) in answers" :key="'i' + i">
						<obj-input v-if="exam.answerType == 'obj'" :seqIndex="i" :examNo="i+1" :key="forceRenderId"></obj-input>
						<sbj-input v-else-if="exam.answerType == 'sbj'" :seqIndex="i" :examNo="i+1" :key="forceRenderId"></sbj-input>
						<des-input v-else-if="exam.answerType == 'des'" :seqIndex="i" :examNo="i+1" :key="forceRenderId"></des-input>
					</li>
				</ul>
				<p v-else class="text-align-center padding-vertical">로딩중...</p>
			</div>
			<div class="block">
				<div class="row">
					<div class="left"></div>
					<div class="right">
						<button class="button button-fill" @click="submitButtonClick" v-if="mode == 'ANSWER'">답안제출</button>
						<span class="txt-color-primary" v-else>답안 제출이 완료 되었습니다.</span>
					</div>
				</div>
			</div>
		</template>
		<template v-if="viewMode=='EXAM-VIEW'">
			<div class="block block-strong">
				<img :src="getExamImgUrl()" width="100%" style="margin-bottom:10px;"/>
				<img v-if="isNeedObjectImg()" :src="getObjectiveImgUrl()" width="100%"/>
			</div>
			<div class="block"><!-- SCROLL SAFE BLOCK --></div>
			<div class="toolbar toolbar-bottom" style="position:absolute; height:auto; color:unset;">
				<div class="list no-margin-vertical">
					<ul>
						<li>
							<div class="item-content item-inner">
								<div class="row" style="width:100%">
									<div class="col-50">
										<button class="button button-outline inline-btn" @click="movePrevExam()" :class="{ disabled: (examViewExamIndex <= 0) }">이전</button>
										<button class="button button-outline inline-btn" @click="moveNextExam()" :class="{ disabled: (examViewExamIndex >= (answers.length -1)) }">다음</button>
									</div>
									<div class="col-50 text-align-right">
										<button class="button button-fill inline-btn" @click="submitButtonClick" v-if="mode == 'ANSWER'">답안제출</button>
										<span class="txt-color-primary" v-else>답안제출 완료.</span>
									</div>
								</div>
							</div>
						</li>
						<li v-if="getExamType() == 'obj'">
							<obj-input :seqIndex="examViewExamIndex" :examNo="(examViewExamIndex+1)" :key="forceRenderId"></obj-input>
						</li>
						<li v-else-if="getExamType() == 'sbj'">
							<sbj-input :seqIndex="examViewExamIndex" :examNo="(examViewExamIndex+1)" :key="forceRenderId"></sbj-input>
						</li>
						<li v-else-if="getExamType() == 'des'">
							<des-input :seqIndex="examViewExamIndex" :examNo="(examViewExamIndex+1)" :key="forceRenderId"></des-input>
						</li>
					</ul>
				</div>
			</div>
		</template>
    
  </f7-page>
</template>

<script>
  import Vue from 'vue';
	import { f7 } from 'framework7-vue';
	import store from '../../../../js/store';

	import MODULE from '../../../../js/common/module';
	import AUTH from '../../../../js/common/auth.js';
	import PAGES from '../../../../js/pages';
	import API from '../../../../js/common/api.js';
	import CONST from '../../../../js/common/constant';

	import ObjInput from '../../../../components/answer/obj-input';
	import SbjInput from '../../../../components/answer/sbj-input';
	import DesInput from '../../../../components/answer/des-input';
  
	export default {
		components: {
			ObjInput,
			SbjInput,
			DesInput,
		},
    data() {
      return {
				forceRenderId: 1,
				viewMode: "EXAM-VIEW",
				mode: "ANSWER",
				examViewExamIndex: 0,

				clinicMode: "incorrect",
				linkExamArray: [],

				answers: []
      }
		},
		mounted() {
			var _this = this;

			_this.clinicMode = _this.$f7route.context.clinicMode;
			_this.linkExamArray = _this.$f7route.context.linkExamArray;

			setTimeout(function() {
				_this.loadClinicSelfStudyInfo();
			}, 300);
			//_this.test();
		},
    methods: {
			toggleViewMode() {
				if (this.viewMode == 'ANSWER-VIEW') {
					this.viewMode = 'EXAM-VIEW';
				} else {
					this.viewMode = 'ANSWER-VIEW';
				}
			},
			movePrevExam() {
				if (this.examViewExamIndex > 0) {
					this.examViewExamIndex--;
				}
			},
			moveNextExam() {
				if (this.examViewExamIndex < (this.answers.length-1)) {
					this.examViewExamIndex++;
				}
			},
			isNeedObjectImg() {
				if (this.answers.length == 0) {
					return false;
				}

				var answerItem = this.answers[this.examViewExamIndex];
				if (answerItem.answerType == "obj") {
					return true;
				}

				return false;
			},
			getExamType() {
				if (this.answers.length == 0) {
					return "";
				}

				var answerItem = this.answers[this.examViewExamIndex];
				return answerItem.answerType;
			},
			getExamImgUrl() {
				if (this.answers.length == 0) {
					return "";
				}

				var answerItem = this.answers[this.examViewExamIndex];
				var imgUrl = MODULE.Util.getExamPrintImgUrl(answerItem.examKey, answerItem.answerType, "exam");

				return imgUrl;
			},
			getObjectiveImgUrl() {
				if (this.answers.length == 0) {
					return "";
				}
				
				var answerItem = this.answers[this.examViewExamIndex];
				var imgUrl = MODULE.Util.getExamPrintImgUrl(answerItem.examKey, answerItem.answerType, "objective");

				return imgUrl;
			},
			loadClinicSelfStudyInfo() {
				var _this = this;

				let param = {
					pClinicMode: _this.clinicMode,
					pLinkExamArray: _this.linkExamArray
				};

				API.jsonRequest({
					url: API.getClinicSelfStudyInfoUrl(),
					data: param
				}).then(function (data) {
					
					var commonObj = store.getters.commonObj;
					commonObj.mode = "ANSWER";
					commonObj.answers = data.answers;
					_this.mode = commonObj.mode;
					_this.answers = commonObj.answers;

				}).catch(function (code) {
					if (code == CONST.resultCode.EMPTY) {
						PAGES.back();
						MODULE.DialogBox.message("추출된 문항이 없습니다.");
						return;
					}

					MODULE.UITool.catchBlock(code, PAGES, AUTH);
				});
			},
			loadClinicHomeworkInfo() {
				// clinic는 homework를 제공하지 않는다.
			},
			saveClinicResult() {
				var _this = this;

				var url = API.saveClinicSelfStudyUrl();
				var param = {
					pAnswers: _this.answers
				};

				var result = MODULE.Util.checkValidateAnswers(param.pAnswers);
				
				var message = "";
				if (result.code != "OK") {					
					if (result.code == "EMPTY-ANSWER") {
						message = "비어있는 정답이 있습니다.<br/>조건에 맞지 않는 문항은 오답처리 됩니다.<br/>그래도 제출 할까요 ?";
					} else if (result.code == "OVERFLOW-LENGTH") {
						message = "정답이 너무 길어 잘리는 문항이 있습니다.<br/>잘린 문항은 오답처리 됩니다.<br/>그래도 제출 할까요 ?";
					}
				} else {
					message = "정답을 전송하고나면 변경할 수 없습니다.<br/>제출할까요 ?";
				}

				MODULE.DialogBox.okcancel(
					"정답 제출 확인", message,
					function() {	// on OK.

						API.jsonRequest({
							url: url,
							data: param
						}).then(function (data) {

							var commonObj = store.getters.commonObj;
							commonObj.mode = "SCORE";
							commonObj.answers = data.answers;

							_this.mode = commonObj.mode;
							_this.answers = commonObj.answers;

							_this.forceRenderId++;
						}).catch(function (code) {
							MODULE.UITool.catchBlock(code, PAGES, AUTH);
						});
					}
				);
			},
			submitButtonClick() {
				this.saveClinicResult();
			},
    }
  }

</script>